import React from 'react';
import { Head } from '@inertiajs/react';
import TagForm from '@/components/admin/blog/TagForm';

interface Props {
  tag?: any;
}

const New: React.FC<Props> = () => {
  return (
    <>
      <Head title="New Tag" />
      <TagForm isEditing={false} />
    </>
  );
};

export default New;
